<template>
	<div class="container">
		<div class="content">
			<BaseTypography size="l" color="white" weight="bold">Your referral link</BaseTypography>
			<BaseTypography size="s" color="gray">{{ props.link }}</BaseTypography>
		</div>

		<BaseButton variant="icon">
			<CopyIcon class="icon" />
		</BaseButton>
	</div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseTypography from '@/components/ui/BaseTypography.vue';
import CopyIcon from '@/assets/icons/copy.svg?component';

const props = defineProps<{
	link: string;
}>();
</script>

<style scoped>
.container {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.1) -1.65%,
		rgba(185, 218, 255, 0.1) 52.48%,
		rgba(2, 122, 255, 0.1) 104.15%
	);
	box-shadow: 0px 0px 25px rgba(2, 122, 255, 0.15);
	border-radius: 16px;

	cursor: pointer;
}

.content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	gap: 4px;
}

.icon {
	stroke: #fff;
}
</style>
